// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iVws","col":"styles_col__3ShJP"};